import { createRoot } from 'react-dom/client'
import { createElement } from 'react'

import { Bootstrap } from './Bootstrap'

export function renderApp() {
  const container = document.getElementById('mount')

  if (container !== null) {
    const root = createRoot(container)

    root.render(createElement(Bootstrap))
  } else {
    console.error('HTML element #mount does not exist, cannot render application')
  }
}
